/** First path segment after /admin or /tenant — FRONTEND_ARCHITECTURE.md §5.7 */
export function getNavSegment(pathname: string): string {
  const match = pathname.match(/^\/(admin|tenant)\/([^/?#]+)/);
  return match?.[2] ?? '';
}

export function isNavItemActive(itemPath: string, currentPathname: string): boolean {
  const itemSegment = getNavSegment(itemPath);
  const currentSegment = getNavSegment(currentPathname);
  return itemSegment !== '' && itemSegment === currentSegment;
}
